export default {
  title: 'sicc',

  colors: {
    primary: '#101037',
    secondary: '#c09571',
    tertiary: '#f297cf',
    text: '#A6A4A7',
    textInBg: '#ffffff',
    borders: '#707070',
    borderBotaoEMerkator: '#ffffff',
    boxShadow: '#000000',
  },
  transparentColors: {
    primary: 'rgba(208,27,139,0.5)',
    secondary: 'rgba(192,149,113,0.7)',
  },
};
